import roles from '../SecuredArea/roles';
import excludeCases from '../SecuredArea/excludeCases';

export const roleCheck = (rolesArray, urls, userInfo) => {
  let result = false;
  const availableUrls = [];

  if (Array.isArray(urls)){
    urls.forEach(url => {
      if (rolesArray.includes(roles[url])) {
        if(userInfo.data?.status !== excludeCases[url]) {
          availableUrls.push(url)
          result = true
        }
      }
    })
  }else {
    if (rolesArray.includes(roles[urls])) {
      if(userInfo.data?.status !== excludeCases[urls]) {
        result = true
      }
    }
  }
  return {result, availableUrls}
}
